<template>
    <div class="sidebar--shop">
        <ShopSearchBar />
        <FilterGroup
            taxonomy="category"
            :name="categoriesText"
            :terms="categories" />
        <FilterGroup 
            v-for="attribute in attributes"
            :key="attribute.slug"
            :name="attribute.name"
            :taxonomy="attribute.slug"
            :terms="attribute.terms"
        />
        <CapacitySlider />     
    </div>    
</template>
<script>

import {mapGetters} from 'vuex'
import ShopSearchBar from  "./ShopSearchBar.vue";
import FilterGroup from "./FilterGroup.vue";
import CapacitySlider from "./CapacitySlider.vue";

export default {
    components : {
        ShopSearchBar,
        FilterGroup,
        CapacitySlider,
    },
    computed : {
        ...mapGetters([
            'attributes',
            'categories',
            'getRegions'
        ]),
        categoriesText() {
          return TG.vue.labels.product_attributes.category || "Category"
        }
    }
}
</script>